import type { AccessibleSVGProps } from '@core/svg'
import { AccessibleSVG } from '@core/svg'

/**
 * Picture SVG Icon for upload image button.
 */
export const Picture: React.FC<AccessibleSVGProps> = (props) => (
  <AccessibleSVG
    width="100%"
    height="100%"
    viewBox="0 0 16 16"
    aria-hidden={true}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.5 2.5H1.5C1.22344 2.5 1 2.72344 1 3V13C1 13.2766 1.22344 13.5 1.5 13.5H14.5C14.7766 13.5 15 13.2766 15 13V3C15 2.72344 14.7766 2.5 14.5 2.5ZM5.28125 4.75C5.83281 4.75 6.28125 5.19844 6.28125 5.75C6.28125 6.30156 5.83281 6.75 5.28125 6.75C4.72969 6.75 4.28125 6.30156 4.28125 5.75C4.28125 5.19844 4.72969 4.75 5.28125 4.75ZM13.3109 11.5797C13.2882 11.5988 13.2594 11.6093 13.2297 11.6094H2.76875C2.7 11.6094 2.64375 11.5531 2.64375 11.4844C2.64375 11.4547 2.65469 11.4266 2.67344 11.4031L5.33437 8.24687C5.37812 8.19375 5.45781 8.1875 5.51094 8.23125C5.51562 8.23594 5.52188 8.24062 5.52656 8.24687L7.07969 10.0906L9.55 7.16094C9.59375 7.10781 9.67344 7.10156 9.72656 7.14531C9.73125 7.15 9.7375 7.15469 9.74219 7.16094L13.3297 11.4047C13.3703 11.4563 13.3641 11.5359 13.3109 11.5797Z"
      fill={props.fill ?? 'currentColor'}
    />
  </AccessibleSVG>
)
